import { render, staticRenderFns } from "./CommentsTable.vue?vue&type=template&id=9ecc4b8c"
import script from "./CommentsTable.vue?vue&type=script&lang=js"
export * from "./CommentsTable.vue?vue&type=script&lang=js"
import style0 from "./CommentsTable.vue?vue&type=style&index=0&id=9ecc4b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports